import { themeObject } from '../../../../lib';

export interface DashboardEmptyStateProps {
    refreshData: any;
}

export const dashboardEmptyStateHelperStyles = {
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'column',
        mx: 42.9375,
    },
    image: {
        marginBottom: '16px',
    },
    mainText: {
        ...themeObject.typography.h2,
        color: themeObject.palette.primary[700],
        fontSize: '26px',
        mb: 2,
    },
    secondaryText: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body3,
        ...themeObject.typography.body.regular,
        lineHeight: '100%',
        color: themeObject.palette.grayScale[700],
        mb: 2,
    },
    refreshButton: {
        borderRadius: '64px',
        width: '180px',
        height: '35px',
        '& .MuiTypography-root': {
            fontFamily: 'Red Hat Text',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '24px',
            color: themeObject.palette.grayScale[700],
            ml: '2px',
        },
    },
};
